import { clsx } from 'clsx'
import { Space, SpaceProps } from 'component/Space'
import { ClickAction, useOnClickAction } from 'hook/useOnClickAction'
import css from './Card.module.scss'

export type CardProps = SpaceProps & {
  action?: ClickAction | false,
  active?: boolean
  secondary?: boolean
  tertiary?: boolean
  stub?: boolean
}

export const Card = (props: CardProps) => {
  const { action, active, secondary, tertiary, stub } = props
  const { busy, onClick } = useOnClickAction(props)

  const className = clsx(
    props.className,
    css.card,
    action != null && css.action,
    busy && css.busy,
    active && css.active,
    secondary && css.secondary,
    tertiary && css.tertiary,
    stub && css.stub,
  )

  return <Space {...props} className={className} onClick={action ? onClick : undefined} />
}
